import { render } from "./EditRadio.vue?vue&type=template&id=51e0ff06&scoped=true"
import script from "./EditRadio.vue?vue&type=script&lang=js"
export * from "./EditRadio.vue?vue&type=script&lang=js"

import "./EditRadio.vue?vue&type=style&index=0&id=51e0ff06&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51e0ff06"]])

export default __exports__